/**
 * Types de la fiche exécutive : analyse spatiale (§4, §3.5.3), décisions du maire (§5) et
 * registre des interventions.
 */

/** Décision du maire sur un équipement (§5). */
export enum ValidationStatut {
  EN_ATTENTE = 'en_attente',
  VALIDEE = 'validee',
  REJETEE = 'rejetee',
  CONTRE_EXPERTISE = 'contre_expertise',
}

/**
 * Le motif est obligatoire pour ces deux issues : l'agent qui a saisi la donnée ne dispose de rien
 * d'autre pour corriger. Le backend refuse la décision sans motif (422).
 */
export const STATUTS_EXIGEANT_UN_MOTIF: ValidationStatut[] = [
  ValidationStatut.REJETEE,
  ValidationStatut.CONTRE_EXPERTISE,
]

/** Cycle de vie d'une intervention physique sur un équipement (§5). */
export enum InterventionStatut {
  PROGRAMMEE = 'programmee',
  EN_COURS = 'en_cours',
  REALISEE = 'realisee',
  ANNULEE = 'annulee',
}

/** Un équipement voisin, avec sa distance réelle en mètres (§4.1). */
export interface VoisinProche {
  iftId: number
  nom: string
  typeCode: string
  typeLibelle: string
  distanceMetres: number
}

/** Zone de chalandise autour de l'équipement (§4.2). */
export interface Chalandise {
  rayonMetres: number
  surfaceHectares: number
  total: number
  typologies: { code: string; libelle: string; nombre: number }[]
}

export interface AnalyseSpatiale {
  iftId: number
  nom: string
  typeCode: string
  commune: { cmnCode: string; communeName: string; '@id': string }
  proximite: VoisinProche[]
  chalandise: Chalandise
}

/** Une intervention telle que servie par /api/interventions. */
export interface Intervention {
  '@id'?: string
  id?: string
  itvTypeTache: string
  itvDescription?: string | null
  itvResponsable?: string | null
  itvStatut: InterventionStatut
  itvDatePrevue?: string | null
  itvDateRealisee?: string | null
}

/** Charge utile de création d'une intervention. Les relations sont passées en IRI. */
export interface InterventionCreation {
  infrastructure: string
  commune: string
  itvTypeTache: string
  itvDescription?: string | null
  itvResponsable?: string | null
  itvStatut: InterventionStatut
  itvDatePrevue?: string | null
}
